import { tryCatch, fromPredicate } from 'fp-ts/lib/Option';
import ViewConfig, { View } from 'reducers/ViewConfigType';

export const getIsDynamicView = (viewConfig: ViewConfig, viewName: string) =>
    fromPredicate<View>(Boolean)(viewConfig.views[viewName])
        .chain((view) => fromPredicate<string>(Boolean)(view.config))
        .chain((c) => tryCatch(() => JSON.parse(c) as { isDynamicView?: boolean }))
        .mapNullable((c) => c.isDynamicView)
        .getOrElse(false);
